'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  flex: 1;\n  padding-left: ', ';\n  padding-right: ', ';\n  color: ', ';\n'], ['\n  width: 100%;\n  flex: 1;\n  padding-left: ', ';\n  padding-right: ', ';\n  color: ', ';\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var color = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors


var TextField = _styledComponents2.default.div(_templateObject, function (_ref) {
  var preIcon = _ref.preIcon;
  return (preIcon ? 36 : 10) + 'px';
}, function (_ref2) {
  var postIcon = _ref2.postIcon;
  return (postIcon ? 36 : 10) + 'px';
}, function (_ref3) {
  var theme = _ref3.theme;
  return color[theme];
});

TextField.propTypes = {
  preIcon: _propTypes2.default.bool,
  postIcon: _propTypes2.default.bool
};
TextField.defaultProps = {
  preIcon: false,
  postIcon: false
};
exports.default = TextField;